import ChatDepartmentsView from "../../../views/ChatDepartments";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const chatDepartmentsRoutes = [
  {
    menuName: MenuNames.LOGISTICS_CHAT_DEPARTMENTS,
    path: "/chat-departments",
    component: ChatDepartmentsView,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_CHAT_DEPARTMENTS,
    path: "/chat-departments/:id(\\d+)",
    component: ChatDepartmentsView,
    exact: true,
  },
];

export default chatDepartmentsRoutes;
